import { ITrustBannerProps, Section, TrustBanner } from '@web_opxp/components';
import { useTranslation } from '@web_opxp/language';
import * as React from 'react';

const TrustBannerSection: React.FC = () => {
  const { language, t } = useTranslation();
  if (!language) {
    return null;
  }
  const trustBannerPath = `https://cms.cdn.neuronation.com/assets/edison/trust/v3/${language}`;
  const bannerProps: ITrustBannerProps = {
    leftTitle: t('opxp.common:TrustBanner.Leonardo.Title'),
    leftItems: [
      { label: t('opxp.common:TrustBanner.Leonardo.Award'), src: `${trustBannerPath}/trust1.svg` },
      { label: t('opxp.common:TrustBanner.Leonardo.Education'), src: `${trustBannerPath}/trust2.svg` },
      { label: t('opxp.common:TrustBanner.Leonardo.Health'), src: `${trustBannerPath}/trust3.svg` },
    ],
    rightTitle: t('opxp.common:TrustBanner.Cooperation.Title'),
    rightItems: [
      { label: t('opxp.common:TrustBanner.Cooperation.Partner1'), src: `${trustBannerPath}/trust4.svg` },
      { label: t('opxp.common:TrustBanner.Cooperation.Partner2'), src: `${trustBannerPath}/trust5.svg` },
      { label: t('opxp.common:TrustBanner.Cooperation.Partner3'), src: `${trustBannerPath}/trust6.svg` },
    ],
    popupTitle: t('opxp.common:TrustBanner.LeonardoAwardPopup'),
  };
  return (
    <Section className="trust-banner-section">
      <TrustBanner {...bannerProps} />
    </Section>
  );
};

export default TrustBannerSection;
